import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getMySubscription,
  getProjects,
  getQueryLogs,
  handelCatch,
  setCopyData,
  setIsOpen,
  setIsShowProjectPopup,
  setProjectEditData,
  setShowSubscriptionPopup,
  showSuccess,
  throwError,
  updateLogging,
} from "store/globalSlice";
import { icons } from "utils/constants";
import {
  Button,
  DashboardQuery,
  Modal,
  Projectpopup,
  SubscriptionExpirePopup,
  Switch,
} from "components";
import { orderBy, take, times } from "lodash";
import moment from "moment";
import { getDataFromLocalStorage } from "utils/helpers";
import { Tooltip as ReactTooltip } from "react-tooltip";
import switchAnimation from "assets/images/animation/switchAnimation.json";
import Lottie from "lottie-react";
import "react-toastify/dist/ReactToastify.css";
import "./Dashboard.scss";
import UserEditDetailPopup from "components/layouts/UserEditDetailPopup";
import Logs from "pages/Myprojects/Logs";

const chainIcon = {
  unification: icons.unodeChain,
  shibarium: icons.shibariumChain,
  ethereum: icons.ethereumChain,
};
const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const reduxData = useSelector((state) => state.global);
  const { isSubscription, isDarkMode, isOpen } = reduxData || {};
  let subEnddate = localStorage.getItem("subscriptionEndDate");
  let subEndMinute = localStorage.getItem("subscriptionEndMinute");
  const latestAccount = getDataFromLocalStorage("address");
  const { first_name } = getDataFromLocalStorage();
  const [actionID, setActionID] = useState(null);
  const [projectList, setProjectList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [staticOption, setStaticOption] = useState(null);
  const [queryData, setQueryData] = useState({
    used: 0,
    available: 0,
    to_vest: 0,
  });

  const handleAddNetwork = async (elem) => {
    const { rpc_end_point, type, name } = elem;
    try {
      if (window.ethereum) {
        // await window.ethereum.enable();

        let customNetwork = {};
        if (type === "unification") {
          customNetwork = {
            chainId: `0x6D1`,
            chainName: name,
            nativeCurrency: {
              name: "UND",
              symbol: "UND",
              decimals: 18,
            },
            rpcUrls: [rpc_end_point],
          };
        } else if (type === "shibarium") {
          customNetwork = {
            chainId: `0x6D`,
            chainName: name,
            nativeCurrency: {
              name: "BONE",
              symbol: "BONE",
              decimals: 18,
            },
            rpcUrls: [rpc_end_point],
          };
        } else if (type === "ethereum") {
          customNetwork = {
            chainId: `0x1`,
            chainName: name,
            nativeCurrency: {
              name: "Ethereum",
              symbol: "ETH",
              decimals: 18,
            },
            rpcUrls: [rpc_end_point],
          };
        }

        await window?.ethereum?.request({
          method: "wallet_addEthereumChain",
          params: [customNetwork],
        });
        dispatch(showSuccess(`${name} is added Successfully`));
      } else {
        console.error("MetaMask not detected");
        dispatch(throwError("MetaMask not detected"));
      }
    } catch (error) {
      console.error("Error adding custom network:", error);
      dispatch(handelCatch(error));
    }
  };
  const fetchProjects = async () => {
    const res = await dispatch(getProjects());
    let newList = res?.data?.map((elem) => {
      let newObject = {
        ...elem?.["Project"],
        type: elem?.type,
        sub_type: elem?.sub_type,
      };
      return newObject;
    });
    setProjectList(newList ? orderBy(newList, "project_id") : []);
    setLoading(false);
  };
  const fetchQueryUsage = async () => {
    const res = await dispatch(getQueryLogs());
    setQueryData({
      used: res?.data?.used || 0,
      available: res?.data?.available || 0,
      to_vest: res?.data?.to_vest || 0,
    });
  };
  const handleUpdateLogging = async () => {
    let payload = {
      // status: JSON.stringify(!JSON.parse(actionID.logging)),
      status: actionID?.logging === "true" ? false : true,
      apikey: actionID?.apikey,
    };
    const queryPayload = new URLSearchParams(payload).toString();
    const res = await dispatch(
      updateLogging(actionID?.project_id, queryPayload)
    );
    if (res?.status === 200) {
      dispatch(showSuccess(res?.data.message));
      setProjectList((prev) => {
        prev.forEach((elm) => {
          if (elm.project_id === actionID?.project_id) {
            elm.logging = JSON.stringify(!JSON.parse(actionID?.logging));
            // elm.logging = actionID.logging === "true" ? true : false
          }
        });
        return prev;
      });
      // fetchProjects()
      setActionID(null);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchQueryUsage();
    fetchProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [latestAccount]);

  const displayPage = take(projectList, 3);
  const currentHour = +moment().format("HH");
  let greetingMessage = "Good Morning";
  if (currentHour < 12) greetingMessage = "Good Morning";
  else if (currentHour >= 12 && currentHour <= 17)
    greetingMessage = "Good Afternoon";
  else if (currentHour >= 17 && currentHour <= 24)
    greetingMessage = "Good Evening";

  useEffect(() => {
    if (localStorage.NowPaymentDone === "1") {
      if (!first_name) {
        setIsModalOpen(true);
      }
      localStorage.removeItem("NowPaymentDone");
      dispatch(getMySubscription());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const convertMinsToHrsMins = (mins) => {
    let h = Math.floor(mins / 60);
    let m = Math.round(mins % 60);
    return `${h > 0 ? `${h} hour${h > 1 ? "s" : ""} ` : ""}${m} minute${
      m > 1 ? "s" : ""
    }`;
  };
  return (
    <div
      id={`${isDarkMode ? "dashboard-container-dark" : "dashboard-container"}`}
      className={`cps-38 cpe-38 cpt-26 w-100 ${
        isDarkMode ? "custom-scroll-dark" : "custom-scroll"
      }`}
    >
      <SubscriptionExpirePopup />
      <Projectpopup fetchProjects={fetchProjects} />
      {isModalOpen && (
        <UserEditDetailPopup
          onHide={() => {
            setIsModalOpen(false);
            localStorage.removeItem("NowPaymentDone");
          }}
          setIsModalOpen={setIsModalOpen}
        />
      )}
      {actionID && (
        <Modal width="368px" hideCloseButton isDarkMode={isDarkMode}>
          <div>
            <div className="f-center">
              <Lottie
                animationData={switchAnimation}
                loop={true}
                autoplay={true}
                style={{ height: "200px" }}
              />
            </div>
            <div
              className={`text-center text-18-600 ${
                isDarkMode ? "color-ffff" : "color-2749"
              } cmb-10`}
            >
              {actionID?.logging === "true" ? "Disable" : "Enable"} Logging
            </div>
            <div
              className={`text-center text-16-400 ${
                isDarkMode ? "color-c9c9" : "color-7e91"
              }  cmb-26`}
            >
              {actionID?.logging === "true" ? (
                <div className="p-2">
                  This will permanently remove all logs previously enabled.
                </div>
              ) : (
                <>
                  Temporarily Enable Logging for <br /> this project.
                </>
              )}
            </div>
            <div className="f-center gap-3">
              <Button
                btnStyle="GD"
                btnText="Cancel"
                className="cps-45 cpe-45"
                onClick={() => {
                  setActionID(null);
                }}
              />
              <Button
                btnStyle={actionID?.logging === "true" ? "SD" : "RD"}
                btnText={actionID?.logging === "true" ? "Disable" : "Enable"}
                className="cps-45 cpe-45"
                onClick={handleUpdateLogging}
              />
            </div>
          </div>
        </Modal>
      )}
      {isOpen && (
        <Logs
          isDarkMode={isDarkMode}
          data={projectList}
          staticOption={staticOption}
        />
      )}
      {loading ? (
        <>
          <div
            className={`${
              isDarkMode ? "skeleton-dark" : "skeleton"
            } h-40 br-10 w-50 mb-2`}
          />
          <div
            className={`${
              isDarkMode ? "skeleton-dark" : "skeleton"
            } h-20 br-8 w-50`}
          />
          {isSubscription && (
            <div
              className={`${
                isDarkMode ? "skeleton-dark" : "skeleton"
              } h-99 br-8 cmt-30 g-0 `}
            />
          )}
          <div
            className={`${
              isDarkMode ? "skeleton-dark" : "skeleton"
            } h-30 br-8 cmt-38 g-0 `}
          />
          <div className="row cmt-20">
            {times(3, (index) => {
              return (
                <div className="col-md-4" key={index}>
                  <div
                    className={`br-14 cp-18 ${
                      isDarkMode ? "skeleton-dark" : "skeleton"
                    }`}
                  >
                    <div className="d-flex justify-content-between">
                      <div>
                        <div
                          className={`text-12-500 ${
                            isDarkMode ? "color-c9c9" : "color-7e91"
                          } v-hide`}
                        >
                          0
                        </div>
                        <div
                          className={`text-24-600 ${
                            isDarkMode ? "color-ffff" : "color-2749"
                          } mb-3 v-hide`}
                        >
                          0
                        </div>
                      </div>
                    </div>
                    <div
                      className={`text-16-400 ${
                        isDarkMode ? "color-c9c9" : "color-7e91"
                      } v-hide`}
                    >
                      0
                    </div>
                    <div className="d-flex cmt-32 v-hide">
                      <div className="f-center gap-2 cpt-8 cpb-10 cps-10 cpe-10 br-8 pointer">
                        <span
                          className={`text-12-600 ${
                            isDarkMode ? "color-ffff" : "color-2749"
                          }`}
                        >
                          API Key
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <>
          <div
            className={`text-26-700 un fb-center ${
              isDarkMode ? "color-ffff" : "color-2749"
            }`}
          >
            {greetingMessage}, 👋 {`${first_name ? `${first_name}!` : ""} `}
            {isSubscription ? (
              subEnddate <= 0 && subEndMinute < 1 ? (
                <span className="text-16-700 rounded-3 cp-10 cps-20 cpe-20 color-4639 b-4639">
                  Subscription expired
                </span>
              ) : (
                <span
                  className={`text-16-700 rounded-3 cp-10 cps-20 cpe-20 ${
                    subEnddate <= 7 ? "color-4639 b-4639" : "color-56ff b-56ff"
                  }`}
                >
                  {`Subscription due in ${
                    subEnddate > 0
                      ? `${subEnddate} days`
                      : convertMinsToHrsMins(subEndMinute)
                  }`}
                </span>
              )
            ) : (
              ""
            )}
          </div>
          <div
            className={`text-66-400 ${
              isDarkMode ? "color-c9c9" : "color-7e91"
            } cmb-26 un`}
          >
            {/* Today is a great day to conduct financial activities. */}
          </div>
          {isSubscription && <DashboardQuery queryData={queryData} />}

          <div className="fb-center cmt-38 g-0 un">
            <div
              className={`text-20-700 ${
                isDarkMode ? "color-ffff" : "color-2749"
              }`}
            >
              My Projects
            </div>
            {projectList?.length > 0 && (
              <div
                className={`text-14-600 ${
                  isDarkMode ? "color-ffff" : "color-2749"
                } fa-center gap-1 pointer`}
                onClick={() => {
                  navigate("/my-projects");
                }}
              >
                <span>View all projects</span>
                <span className="h-20 d-flex">
                  <img
                    src={isDarkMode ? icons.arrowRightLight : icons.arrowRight}
                    alt="emptyProject"
                    className="fit-image"
                  />
                </span>
              </div>
            )}
          </div>
          {projectList?.length === 0 ? (
            <div className="text-center cmt-50 cpb-50">
              <div style={{ height: "250px" }}>
                <img
                  src={
                    isDarkMode ? icons.emptyProjectLight : icons.emptyProject
                  }
                  alt="emptyProject"
                  className="fit-image"
                />
              </div>
              <div
                className={`text-20-600 ${
                  isDarkMode ? "color-ffff" : "color-2749"
                } cmb-20 cmt-26`}
              >
                You haven’t created project
              </div>
              <div className="f-center">
                <Button
                  btnStyle="PD"
                  btnText="Create new project"
                  onClick={() => {
                    if (isSubscription) {
                      dispatch(setProjectEditData(null));
                      dispatch(setIsShowProjectPopup(true));
                    } else {
                      dispatch(setShowSubscriptionPopup(true));
                    }
                  }}
                />
              </div>
            </div>
          ) : (
            <div className="row cmt-20">
              {displayPage?.map((elm, index) => {
                const {
                  name,
                  network,
                  query_count,
                  type,
                  project_id,
                  logging,
                  api_key,
                } = elm;
                return (
                  <div className="col-md-4 un" key={index}>
                    <div
                      className={`br-14 ${isDarkMode ? "" : "cp-18"} ${
                        isDarkMode ? "card-block-dark" : "card-block"
                      }`}
                    >
                      <div className={`${isDarkMode ? "dark-card" : ""}`}>
                        <div
                          className="d-flex justify-content-between"
                          onClick={() => {
                            dispatch(setIsShowProjectPopup(true));
                            dispatch(setProjectEditData(elm));
                          }}
                        >
                          <div>
                            <div
                              className={`text-12-500 ${
                                isDarkMode ? "color-c9c9" : "color-7e91"
                              }`}
                            >
                              {network}
                            </div>
                            <div
                              className={`text-24-600 ${
                                isDarkMode ? "color-ffff" : "color-2749"
                              } mb-3`}
                            >
                              {name?.length > 30
                                ? `${name.substring(0, 30)}...`
                                : name}
                            </div>
                          </div>
                          <div className="h-30 d-flex">
                            <img
                              src={chainIcon[type] || icons.unodeChain}
                              alt="chain"
                              className="fit-image"
                            />
                          </div>
                        </div>
                        <div
                          className={`text-16-400 ${
                            isDarkMode ? "color-c9c9" : "color-7e91"
                          }`}
                          onClick={() => {
                            dispatch(setIsShowProjectPopup(true));
                            dispatch(setProjectEditData(elm));
                          }}
                        >
                          {query_count?.toLocaleString()} request (24h)
                        </div>
                        <div className={`fb-center cmt-32`}>
                          <div className="d-flex gap-2">
                            <div
                              className="f-center gap-2 b-dee3 cpt-8 cpb-10 cps-10 cpe-10 br-8 pointer"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                dispatch(
                                  setCopyData({
                                    type: type,
                                    api_key: elm?.api_key,
                                    http_end_point: elm?.http_end_point,
                                    ws_end_point: elm?.ws_end_point,
                                    rpc_end_point: elm?.rpc_end_point,
                                  })
                                );
                              }}
                            >
                              <span className="h-16 d-flex">
                                <img
                                  src={isDarkMode ? icons.keyLight : icons.key}
                                  alt="key"
                                  className="fit-image"
                                />
                              </span>
                              <span
                                className={`text-12-600 ${
                                  isDarkMode ? "color-ffff" : "color-2749"
                                }`}
                              >
                                API Key
                              </span>
                            </div>
                            {elm?.type === "unification" ? (
                              ""
                            ) : (
                              <div
                                className="f-center gap-2 b-dee3 cpt-8 cpb-10 cps-10 cpe-10 br-8 pointer"
                                onClick={() => handleAddNetwork(elm)}
                              >
                                <div
                                  className="h-22 d-flex"
                                  data-tooltip-id={`my-tooltip`}
                                >
                                  <img
                                    src={icons.Metamaskicon}
                                    alt="key"
                                    className="fit-image"
                                  />
                                </div>
                                <ReactTooltip
                                  id={`my-tooltip`}
                                  place="bottom"
                                  content={
                                    <h3
                                      className={`text-16-500 mb-0 ${
                                        isDarkMode ? "color-ffff" : ""
                                      }`}
                                    >
                                      Add Network
                                    </h3>
                                  }
                                  className={isDarkMode ? "dark " : ""}
                                />
                              </div>
                            )}
                          </div>
                          <div className="fa-center gap-2">
                            <div className="download-log">
                              <span
                                className="h-30 d-flex border p-1 br-8"
                                data-tooltip-id={`my-download-tooltip`}
                                onClick={() => {
                                  setStaticOption(`${elm?.project_id}`);
                                  dispatch(setIsOpen(true));
                                }}
                              >
                                <img
                                  src={icons.downloadLog}
                                  alt="trash"
                                  className={`fit-image ${
                                    isDarkMode ? "light-img" : ""
                                  }`}
                                />
                              </span>
                              <ReactTooltip
                                id={`my-download-tooltip`}
                                place="bottom"
                                content={
                                  <h3
                                    className={`text-16-500 mb-0 ${
                                      isDarkMode ? "color-ffff" : ""
                                    }`}
                                  >
                                    Download Log
                                  </h3>
                                }
                                className={isDarkMode ? "dark" : ""}
                              />
                            </div>
                            <div className="switch-block">
                              <div
                                className="d-flex h-20"
                                data-tooltip-id={`my-tooltip-${project_id}}`}
                              >
                                <img
                                  className="fit-image"
                                  src={
                                    isDarkMode
                                      ? icons.infoCircleLight
                                      : icons.infoCircle
                                  }
                                  alt="information"
                                />
                              </div>
                              <ReactTooltip
                                id={`my-tooltip-${project_id}}`}
                                place="bottom"
                                content={
                                  <>
                                    <h3
                                      className={`text-26-700 mb-3 ${
                                        isDarkMode ? "color-ffff" : ""
                                      }`}
                                    >
                                      {logging === "false"
                                        ? "Queries are not tracked."
                                        : "Queries are being tracked."}
                                    </h3>
                                    <p
                                      className={`text-14-400 ${
                                        isDarkMode ? "color-c9c9" : "color-7e91"
                                      } mb-0`}
                                    >
                                      If you encounter issues, enable system
                                      logging for tracking;
                                      <br /> it will auto-disable in 72 hours.
                                    </p>
                                  </>
                                }
                                className={isDarkMode ? "dark" : ""}
                              />
                            </div>
                            <div
                              className="fa-center"
                              data-tooltip-id={`my-tooltip-switch-${project_id}}`}
                            >
                              <Switch
                                checked={logging === "true"}
                                onChange={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setActionID({
                                    project_id: project_id,
                                    logging: logging,
                                    apikey: api_key,
                                  });
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                }}
                              />
                              <ReactTooltip
                                id={`my-tooltip-switch-${project_id}}`}
                                place="bottom"
                                content={
                                  <h3
                                    className={`text-16-500 mb-0 ${
                                      isDarkMode ? "color-ffff" : ""
                                    }`}
                                  >
                                    {logging === "true" ? "Disable" : "Enable"}{" "}
                                    Logging
                                  </h3>
                                }
                                className={isDarkMode ? "dark" : ""}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="bottom-line" />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Dashboard;
